export default "__VITE_ASSET__NHeu5Q6V__"